import React, { PureComponent } from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import bindAll from 'lodash.bindall';
import StageWrapper from './stage-wrapper-share.jsx';
import qs from "qs";
import QRcode from 'qrcode.react';
import { setPlayer } from "../../..";
import { commentSave, shareSave, commentList, getWXSignature } from '../../api/share';
import { me } from '../../api/user';
import { likeToggle, likeGet } from '../../api/like';
import { setCourseRecords, setMyProjects, setCourses, setUser } from "../../reducers/teach";
import LoginRegModal from "../login-reg-modal/login-reg-modal";
import { showLoading } from "../loading/loading";
import EditShareModal from './components/EditShareModal';
import ModalManager from "../modal/modal-manager";
import { getProjectInfo } from '../../api/project';
import message from '../message/message';
import moment from 'moment';
import up from './up.svg';
import down from './down.svg';
import left from './left.svg';
import right from './right.svg';
import preview from './preview-open.png'
import dislike from './thumbs.png'
import like from './thumbs-like.png'
import comment from './comment.png'
import share from './iphone.png'
import styles from './stage-player.css';
import Page from '../page/page';
import wx from 'weixin-js-sdk';
import back from './btn_back.png';
import tips from './bubble_share.png';
import start from './btn_run.png';
import ProjectsDeleteModal from '../../pages/projects/projects-delete-modal'
import { setFullScreen } from '../../../reducers/mode';

class StagePlayer extends PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleClickSeeCommunity',
            'keyClickStart',
            'keyClickEnd',
            'comment',
            'commentSubmit',
            'shareSubmit',
            'shareContentOI',
            'shareContentDesc',
            'getCommentList',
            'chooseKeybord',
            'getProjectInfo',
            'showLogin',
            'shareEdit',
            'handleShare',
            'setLikeToggle',
            'getLikeGet',
            'getUser',
            'getWXSignature',
            'cancelShare',
            'shareTips',
            'handleFullScreen'
        ]);
        this.query = qs.parse(location.search, { ignoreQueryPrefix: true });
        this.state = {
            commentValue: '',
            desc: '',
            oi: '',
            commentArray: null,
            commentTotal: 0,
            keyboard: null,
            projectInfo: {},
            editStatus: false,
            shareStatus: false,
            shareToolip: true,
            isLike: false,
            currentTab: 1,
            shareModel: false
        }
    }

    componentDidMount() {
        this.getCommentList();
        this.getProjectInfo();
        this.getLikeGet();
        this.getUser();
        const viewport = document.querySelector("meta[name=viewport]");
        if (this.props.isPhone) {
            viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no');
            document.querySelector('[class^="index_app"]').style.minWidth = 0;
            document.querySelector('[class^="index_app"]').style.minHeight = 0;
            document.getElementsByTagName('body')[0].style.minWidth = 0;
            document.getElementsByTagName('html')[0].style.minWidth = 0;
            document.getElementsByTagName('body')[0].style.minHeight = 0;
            document.getElementsByTagName('html')[0].style.minHeight = 0;
        }
        // this.props.onSetStageFull()
    }

    componentWillUnmount() {
        if (this.props.isPhone) {
            const viewport = document.querySelector("meta[name=viewport]");
            viewport.setAttribute('content', 'width=1250,viewport-fit=cover,user-scalable=0,maximum-scale=1');
        }
    }

    getUser() {
        me({}, { quiet: !!this.props.username }).then(res => {
            this.props.setUser(res)
        });
    }

    //获取项目信息
    getProjectInfo() {
        const { projectId } = this.props;
        getProjectInfo({
            id: projectId
        }, { quiet: true }).then((res) => {
            if (res) {
                this.setState({
                    projectInfo: res,
                    desc: res.desc,
                    oi: res.oi,
                    keyboard: res.keyboard
                })
                this.getWXSignature();
            }
        })
    }

    //获取评论列表
    getCommentList() {
        const { projectId } = this.props
        commentList({
            to_id: projectId,
            page_size: 100,
        }).then((res) => {
            if (res) {
                this.setState({
                    commentArray: res.data,
                    commentTotal: res.total
                })
            }
        })
    }

    //返回积木块
    handleClickSeeCommunity() {
        this.props.setPlayer(false)
    }

    //评论
    comment(e) {
        this.setState({ commentValue: e.target.value })
    }

    //提交评论
    commentSubmit() {
        const { commentValue } = this.state;
        const { projectId } = this.props;
        try {
            commentSave({
                content: commentValue,
                to_id: projectId
            }, { quiet: true }).then(res => {
                if (res) {
                    this.getCommentList();
                    this.setState({ commentValue: '' });
                }
            });
        } catch (error) {
            // eslint-disable-next-line no-alert
            if (error.msg || error.data) {
                message.show(error.msg.name || error.data);
            } else {
                message.show(error.toString());
            }
        }
    }

    //分享
    shareSubmit() {
        const { projectInfo } = this.state;
        const { desc, oi, keyboard, editStatus } = this.state;
        if (!editStatus && projectInfo.is_public === 1) {
            this.setState({
                editStatus: true
            })
            return
        }
        if (!oi) {
            message.show('操作说明不能为空')
            return
        }
        if (!desc) {
            message.show('作品介绍不能为空')
            return
        }
        try {
            shareSave({
                id: projectInfo.id,
                desc: desc,
                oi: oi,
                keyboard: keyboard,
                is_public: 1
            }, { quiet: true }).then(res => {
                if (res === '更新成功') {
                    if (projectInfo.is_public !== 1) {
                        this.setState({
                            shareStatus: true
                        })
                    } else {
                        message.show('保存成功')
                        setTimeout(() => {
                            this.setState({
                                editStatus: false
                            })
                        }, 1500)
                    }
                }
            })
        } catch (err) {
            if (err.msg || err.data) {
                message.show(err.msg.name || err.data);
            } else {
                message.show(err.toString());
            }
        }
    }

    // 提示分享
    shareTips() {
        this.setState({
            shareModel: !this.state.shareModel
        })
    }

    // 新版-打开编辑分享弹窗
    shareEdit() {
        const { desc, oi, keyboard, projectInfo } = this.state;
        if (window.__wxjs_environment === 'miniprogram') {
            wx.miniProgram.navigateTo({ url: `/pages/share/share?id=${projectInfo.id}` });
        } else {
            ModalManager.open(EditShareModal, {
                onClose: () => {
                    ModalManager.pop();
                    this.getProjectInfo();
                },
                isPlayerOnly: this.props.isPlayerOnly,
                projectInfo,
                desc,
                oi,
                keyboard,
                isPhone: this.props.isPhone
            });
        }
    }

    // 鼠标悬浮-分享
    handleShare(status = false) {
        this.setState({ shareToolip: status })
    }

    shareContentOI(e) {
        this.setState({ oi: e.target.value })
    }

    shareContentDesc(e) {
        this.setState({ desc: e.target.value })
    }

    chooseKeybord(e) {
        this.setState({ keyboard: Number(e.target.value) })
    }

    //虚拟键盘按键
    keyClickStart(event, letter, key) {
        this.props.vm.postIOData("keyboard", {
            keyCode: letter,
            key: key,
            isDown: true,
        });
        event.preventDefault();
    }

    keyClickEnd(event, letter, key) {
        this.props.vm.postIOData("keyboard", {
            keyCode: letter,
            key: key,
            isDown: false,
        });
        event.preventDefault();
    }

    // 获取用户点赞状态
    async getLikeGet() {
        const { projectId } = this.props
        const res = await likeGet({ target_id: projectId })
        if (!!res) {
            this.setState({ isLike: true })
        }
    }

    // 点赞or取消点赞
    async setLikeToggle() {
        const { projectId } = this.props
        const res = await likeToggle({ target_id: projectId }, { quiet: true })
        if (!!res) {
            this.setState({ isLike: res === '点赞成功' ? true : false })
            message.show(res)
            this.getProjectInfo()
        }
    }

    //取消分享
    cancelShare() {
        const { projectInfo } = this.state;
        ModalManager.open(ProjectsDeleteModal, {
            closeAfterSubmit: true,
            onClose: () => {
                ModalManager.pop();
            },
            deleteId: projectInfo.id,
            projectType: 'myshare',
            title: '取消分享',
            content: '是否确认要取消分享该作品?',
            history: this.props.history,
            size:'small'
        })
    }

    //登录
    showLogin() {
        ModalManager.open(LoginRegModal, {
            closeAfterSubmit: true,
            onClose: () => { },
            setUser, setCourseRecords, setMyProjects, setCourses, showLoading
        }, 'login');
    }

    // 返回
    handleBack() {
        if (document.referrer) {
            if ((document.referrer == window.location.href) && this.props.history.length === 2) {
                this.handleClickSeeCommunity()
            } else {
                this.props.history.goBack();
            }
        } else if (this.props.history.length > 2) {
            this.props.history.goBack();
        } else {
            this.handleClickSeeCommunity()
        }
    }

    //全屏
    handleFullScreen() {
        this.props.onSetStageFull()
    }

    //tab切换
    currentTab(index) {
        // this.props.onSetStageFull()
        this.setState({
            currentTab: index
        })
    }

    // 获取微信授权
    getWXSignature() {
        const { projectInfo } = this.state;
        getWXSignature({ url: window.location.href }, { quiet: false }).then(res => {
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: "wx1e1cd35bac6e264d", // 必填，公众号的唯一标识
                timestamp: res.timestamp, // 必填，生成签名的时间戳
                nonceStr: 'zhiao', // 必填，生成签名的随机串
                signature: res.signature, // 必填，签名，见附录1
                jsApiList: ['chooseWXPay', 'onMenuShareAppMessage', 'onMenuShareTimeline'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });

            wx.ready(() => {
                wx.onMenuShareAppMessage({
                    title: projectInfo.title, // 分享标题
                    desc: projectInfo.desc, // 分享描述
                    imgUrl: `http://oss.pkcode.cn/scratch/thumb/${projectInfo.id}.png`, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                })

                //分享到朋友圈
                wx.onMenuShareTimeline({
                    title: projectInfo.title, // 分享标题
                    imgUrl: `http://oss.pkcode.cn/scratch/thumb/${projectInfo.id}.png`, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                })
            })
        })
    }

    render() {
        const {
            isFullScreen,
            isRtl,
            isRendererSupported,
            loading,
            vm, user
        } = this.props;

        const {
            commentValue,
            desc,
            oi,
            commentArray,
            commentTotal,
            projectInfo,
            shareStatus,
            shareToolip,
            currentTab,
            shareModel
        } = this.state;

        return (
            this.props.isPhone || window.__wxjs_environment === 'miniprogram' ? (
                <div className={styles.phoneShareBox}>
                    <div className={styles.leftContent}>
                        <div className={styles.userInfoPhone}>
                            <div className={styles.backBtn} onClick={() => this.handleBack()}>
                                <img src={back}></img>
                            </div>
                            <div className={styles.mobileTitle}>{projectInfo ? projectInfo.title : 'Scratch作品'}</div>
                            <div className={styles.phoneAuthor}>
                                <img src={window.config.staticURL + '/avatar/' + (projectInfo && projectInfo.user && projectInfo.user.avatar || 'default.png')} />
                                <span>{projectInfo && projectInfo.user && projectInfo.user.name}</span>
                            </div>
                        </div>
                        <div>
                            <div className={styles.stageBox} style={{ display: isFullScreen ? 'none' : 'block' }}>
                                <img width={320} height={240} src={`${window.config.staticURL}/thumb/${projectInfo.id}.png`} />
                                <div className={styles.stageStart} onClick={() => this.handleFullScreen()}>
                                    <img src={start} />
                                </div>
                                
                            </div>

                            <div style={{ display: isFullScreen ? 'block' : 'none' }}>
                                <StageWrapper
                                    isFullScreen={isFullScreen}
                                    isRendererSupported={isRendererSupported}
                                    isRtl={isRtl}
                                    loading={loading}
                                    stageSize='middle'
                                    vm={vm}
                                >
                                </StageWrapper>
                            </div>
                        </div>
                    </div>
                    <div className={styles.rightContent}>
                        <div className={styles.tabsTitle}>
                            <span onClick={() => this.currentTab(1)} className={currentTab === 1 ? styles.active : null}>作品介绍</span>
                            <span onClick={() => this.currentTab(2)} className={currentTab === 2 ? styles.active : null}>操作说明</span>
                            <span onClick={() => this.currentTab(3)} className={currentTab === 3 ? styles.active : null}>评论</span>
                        </div>
                        <div className={styles.phoneIntro}>
                            <p style={{ display: currentTab === 1 ? 'block' : 'none' }}>{projectInfo && projectInfo.desc ? projectInfo.desc : '暂无介绍'}</p>
                            <p style={{ display: currentTab === 2 ? 'block' : 'none' }}>{projectInfo && projectInfo.oi ? projectInfo.oi : '暂无说明'}</p>
                            <div className={styles.commentListPhone} style={{ display: currentTab === 3 ? 'block' : 'none' }}>
                                {commentArray instanceof Array && commentArray.length > 0 ? (
                                    commentArray.map(item => (
                                        <div className={styles.commentItemPhone} key={item.id}>
                                            <img src={window.config.staticURL + '/avatar/' + (item.user.avatar || 'default.png')}></img>
                                            <div className={styles.commentContentPhone}>
                                                <div className={styles.commentNamePhone}>{item.user.name}</div>
                                                <div className={styles.commentTimePhone}>{moment(item.updated_at).format("YYYY-MM-DD HH:mm:ss")}</div>
                                                <div className={styles.commentTextPhone}>{item.content}</div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p>暂无评论</p>
                                )}
                            </div>
                        </div>
                    </div>

                    <div style={{ position: 'fixed', right: '24px', bottom: '34px', display: 'flex' }}>
                        {
                            Number(projectInfo && projectInfo.user_id) === Number(user && user.id) &&
                            <div>
                                <button className={styles.cancelBtn} onClick={this.cancelShare}>取消分享</button>
                                <button className={styles.cancelBtn} onClick={this.shareEdit}>编辑</button>
                            </div>
                        }
                        <button className={styles.cancelBtn} onClick={() => this.handleClickSeeCommunity()}>查看代码</button>
                        <button className={styles.shareBtn} onClick={() => this.shareTips()}>分享</button>
                    </div>
                    {
                        shareModel && <div className={styles.tipsShare} onClick={() => this.shareTips()}><img src={tips}></img></div>
                    }

                    <div className={isFullScreen ? styles.keybordeFullScreen : styles.hideKeyborde}>
                        {
                            projectInfo && projectInfo.keyboard === 1 ? (
                                <div className={`${styles.keybordBox} ${styles.keybordPhone}`}>
                                    <div className={styles.diamond}>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 38, 'ArrowUp')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 38, 'ArrowUp')}
                                        ><img src={up} /></span>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 39, 'ArrowRight')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 39, 'ArrowRight')}
                                        ><img src={right} /></span>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 40, 'ArrowDown')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 40, 'ArrowDown')}
                                        ><img src={down} /></span>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 37, 'ArrowLeft')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 37, 'ArrowLeft')}
                                        ><img src={left} /></span>
                                    </div>
                                    <div className={styles.large}>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 32, ' ')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 32, ' ')}
                                        >空格</span>
                                    </div>
                                </div>
                            ) : (null)
                        }
                        {
                            projectInfo && projectInfo.keyboard === 2 ? (
                                <div className={`${styles.keybordBox} ${styles.keybordPhone}`}>
                                    <div className={styles.diamond}>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 87, 'W')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 87, 'W')}
                                        >W</span>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 68, 'D')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 68, 'D')}
                                        >D</span>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 83, 'S')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 83, 'S')}
                                        >S</span>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 65, 'A')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 65, 'A')}
                                        >A</span>
                                    </div>
                                    <div className={styles.large}>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 32, ' ')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 32, ' ')}
                                        >空格</span>
                                    </div>
                                </div>
                            ) : (null)
                        }
                        {
                            projectInfo && projectInfo.keyboard === 3 ? (
                                <div className={`${styles.keybordBox} ${styles.keybordPhone}`}>
                                    <div className={styles.diamond}>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 87, 'W')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 87, 'W')}
                                        >W</span>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 68, 'D')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 68, 'D')}
                                        >D</span>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 83, 'S')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 83, 'S')}
                                        >S</span>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 65, 'A')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 65, 'A')}
                                        >A</span>
                                    </div>
                                    <div className={styles.diamond}>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 38, 'ArrowUp')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 38, 'ArrowUp')}
                                        ><img src={up} /></span>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 39, 'ArrowRight')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 39, 'ArrowRight')}
                                        ><img src={right} /></span>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 40, 'ArrowDown')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 40, 'ArrowDown')}
                                        ><img src={down} /></span>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 37, 'ArrowLeft')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 37, 'ArrowLeft')}
                                        ><img src={left} /></span>
                                    </div>
                                </div>
                            ) : (null)
                        }
                        {
                            projectInfo && projectInfo.keyboard === 4 ? (
                                <div className={`${styles.keybordBox} ${styles.keybordPhone}`}>
                                    <div className={styles.jiugongge}>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 85, 'U')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 85, 'U')}
                                        >U</span>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 73, 'I')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 73, 'I')}
                                        >I</span>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 79, 'O')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 79, 'O')}
                                        >O</span>
                                    </div>
                                    <div className={styles.jiugongge}>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 72, 'H')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 72, 'H')}
                                        >H</span>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 74, 'J')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 74, 'J')}
                                        >J</span>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 75, 'K')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 75, 'K')}
                                        >K</span>
                                    </div>
                                    <div className={styles.jiugongge}>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 90, 'Z')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 90, 'Z')}
                                        >Z</span>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 88, 'X')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 88, 'X')}
                                        >X</span>
                                        <span
                                            onTouchStart={(e) => this.keyClickStart(e, 67, 'C')}
                                            onTouchEnd={(e) => this.keyClickEnd(e, 67, 'C')}
                                        >C</span>
                                    </div>
                                </div>
                            ) : (null)
                        }
                    </div>
                </div>
            ) : (
                <Page isModal={true} title="分享详情">
                    {
                       projectInfo && projectInfo.is_public === 1 &&  Number(projectInfo.user_id) === Number(user && user.id) ? (
                            <div className={styles.shareTitle}>
                                <div className={styles.titleContent}>
                                    <span>点击"编辑"按钮,可修改作品信息</span>
                                    <div>
                                        <button className={styles.cancelBtn} onClick={this.cancelShare}>取消分享</button>
                                        <button className={styles.shareBtn} onClick={this.shareEdit}>编辑</button>
                                    </div>
                                </div>
                            </div>
                        ) : (null)
                    }
                    <div className={styles.shareBox}>
                        <div className={styles.modalMask} style={{ display: shareStatus ? "block" : "none" }}></div>
                        <div className={styles.shareContent}>
                            <div className={styles.shareLeft}>
                                <div className={styles.shareHeader}>
                                    <div className={styles.title}>{projectInfo ? projectInfo.title : 'Scratch作品'}</div>
                                    <button className={styles.shareBack} onClick={() => this.handleClickSeeCommunity()}>查看代码</button>
                                </div>
                                <StageWrapper
                                    isFullScreen={isFullScreen}
                                    isRendererSupported={isRendererSupported}
                                    isRtl={isRtl}
                                    loading={loading}
                                    stageSize='large'
                                    vm={vm}
                                >
                                </StageWrapper>
                                {
                                    projectInfo.is_public === 1 && (
                                        <div className={styles.statistics}>
                                            <div className={styles.iconBar}>
                                                <div className={styles.statusIcons}>
                                                    <div className={styles.iconItems}>
                                                        <img src={preview} alt='' />
                                                        <span>{projectInfo.view}</span>
                                                    </div>
                                                    <div className={styles.iconItems}>
                                                        <img src={this.state.isLike ? like : dislike} onClick={this.setLikeToggle} />
                                                        <span>{projectInfo.like}</span>
                                                    </div>
                                                    <div className={styles.iconItems}>
                                                        <img src={comment} alt='' />
                                                        <span>{commentTotal}</span>
                                                    </div>
                                                    <div
                                                        className={styles.iconItems}
                                                        onMouseEnter={() => this.handleShare(true)}
                                                        onMouseLeave={() => this.handleShare(false)}
                                                    >
                                                        <img src={share} alt='' />
                                                        <span>{projectInfo.share}</span>
                                                        {
                                                            shareToolip && <div className={styles.phoneShare}>
                                                                <QRcode style={{ width: 128, height: 128 }} value={`${location.origin}/teacher/mobile-share?id=${projectInfo.id}`} size={80}></QRcode>
                                                                <span style={{
                                                                    fontSize: 16,
                                                                    marginTop: 12,
                                                                    color: '#101010'
                                                                }}>扫描在手机上打开</span>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {projectInfo.is_public === 1 && (
                                    <div className={styles.comment}>
                                        <span>评论</span>
                                        {
                                            !user || !user.id ? (
                                                <div className={styles.noLogin}>
                                                    <a onClick={() => this.showLogin()}>登录发表留言</a>
                                                    <p>是不是想发表一下自己的看法，赶紧登录发表留言吧！</p>
                                                </div>
                                            ) : (
                                                <div>
                                                    <div className={styles.commentEdit}>
                                                        <img src={window.config.staticURL + '/avatar/' + (user && user.avatar || 'default.png')}></img>
                                                        <textarea placeholder='输入评论' onChange={(e) => this.comment(e)} value={commentValue}></textarea>
                                                    </div>
                                                    <button onClick={() => this.commentSubmit()}>发布</button>
                                                </div>
                                            )
                                        }
                                    </div>
                                )}
                                {projectInfo.is_public === 1 && (
                                    <div className={styles.commentList}>
                                        {commentArray && commentArray.length > 0 ? (
                                            commentArray.map(item => (
                                                <div className={styles.commentItem} key={item.id}>
                                                    <img src={window.config.staticURL + '/avatar/' + (item.user.avatar || 'default.png')}></img>
                                                    <div className={styles.commentContent}>
                                                        <div className={styles.commentName}>{item.user.name}</div>
                                                        <div className={styles.commentText}>{item.content}</div>
                                                        <div className={styles.commentTime}>{moment(item.updated_at).format("YYYY-MM-DD HH:mm:ss")}</div>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className={styles.noComment}>
                                                暂无评论
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div className={styles.shareRight}>
                                <div className={styles.userInfo}>
                                    <img src={window.config.staticURL + '/avatar/' + (user && user.avatar || 'default.png')} />
                                    <span>{projectInfo && projectInfo.user && projectInfo.user.name}</span>
                                </div>
                                <div className={styles.operate}>
                                    <span>操作说明</span>
                                    <p>{oi}</p>
                                </div>
                                <div className={styles.explain}>
                                    <span>作品介绍</span>
                                    <p>{desc}</p>
                                </div>
                            </div>
                        </div>
                    </div >
                </Page>
            )
        );
    }
}

StagePlayer.propTypes = {
    setPlayer: PropTypes.func,
    setUser: PropTypes.func
}

const mapStateToProps = state => ({
    projectId: state.scratchGui.projectState.projectId,
    user: state.teach.user,
    projectInfo: state.teach.projectInfo,
    isPlayerOnly: state.scratchGui.mode.isPlayerOnly,
    isPhone: state.teach.isPhone
});
const mapDispatchToProps = dispatch => ({
    setPlayer: isPlayerOnly => dispatch(setPlayer(isPlayerOnly)),
    setUser: user => dispatch(setUser(user)),
    onSetStageFull: () => dispatch(setFullScreen(true)),
});
export default connect(mapStateToProps, mapDispatchToProps)(StagePlayer);

